<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
@if (!isEncargoRoute()) {
  <app-whatsapp-button></app-whatsapp-button>
}
<app-toast-container position="bottom-right" />
